import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { getExceptionList } from '../../actions/actionType/services/ServiceActionTypes';

import { clearExceptions, getExceptionFailure, getExceptionStarted, getExceptionSuccess } from '../../actions/sagaActions/exceptions/ExceptionSearchSagaAction';

import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { FetchExceptionFailurePayload, FetchExceptionRequest } from '../../actions/types/exceptions/FetchExceptionTypes';

/**
 * Call Gets Schemas by ID API
 * @param schemaName : string
 * @returns api response
 */
export async function callFetchExceptionApi(exceptionName: string, status: string) {
  return apiWrapper.post<{ id: string }>(
    `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/exceptions/search`,
    {
      exceptionNames: [exceptionName],
      status: [status],
      operationName: 'Search',
      exactNameMatch: false,
      exceptionTypes: [
        'Business', 'Data Quality', 'System'
      ]
    },
    headersInstance()
  );
}
/**
 * Saga to get Schema by schemaName
 * @param schemaName:string
 */
export function* fetchExceptionData({ exceptionName, status }: FetchExceptionRequest) {
  yield put(clearExceptions());
  yield put(getExceptionStarted());
  try {
    const { responseBody: exceptions, isError, error } = yield call(callFetchExceptionApi, exceptionName, status);

    if (isError) {
      throw error;
    }

    if (exceptions) {
      yield put(getExceptionSuccess(exceptions.ersExceptions));
    } else {
      throw new Error('No Response');
    }
  } catch (error) {
    const obj: FetchExceptionFailurePayload = {
      error: String(error)
    };
    yield put(getExceptionFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* fetchExceptionSaga() {
  yield takeLatest(getExceptionList.FETCH_EXCEPTION_REQUEST, fetchExceptionData);
}

export const getExceptionSaga = [fork(fetchExceptionSaga)];
